import { IMatchupList, INewsArticleList, IBuyMoreResult, IMatchup } from './interfaces'
import { Storage } from '@/types/amplify'
import _ from 'lodash'
import { config } from '@/../app.config'
import Auth from '@aws-amplify/auth'
import Axios from 'axios'

export default {
  GET_NEWS: async ({ commit, getters }: any): Promise<void | INewsArticleList> => {
    let data: INewsArticleList = {
      panels: []
    }

    return await Auth.currentAuthenticatedUser().then( (res: object) => {
      return Storage.get(config.newsEndpoint, {
        level: 'public',
        expires: 5,
        download: true,
      })
      .then(result => {
        if (_.isObject(result) && _.has(result, 'Body')) {
          // @ts-ignore
          data = JSON.parse(result.Body.toString())
          commit('SET_NEWS', data)
          return data
        }
      })
      .catch(err => {
        console.log('Error: GET_NEWS')
        return data
      })
    })
  },
  GET_MATCHUPS: async ({ commit, getters }: any): Promise<void | IMatchupList> => {
    let data: IMatchupList = {
      matchups: { all: [] }
    } as IMatchupList

    return await Auth.currentAuthenticatedUser().then( (res: object) => {
      return Storage.get(config.matchupEndpoint, {
        level: 'public',
        expires: 5,
        download: true,
      })
      .then(result => {
        if (_.isObject(result) && _.has(result, 'Body')) {
          // @ts-ignore
          data = JSON.parse(result.Body.toString())
          commit('SET_MATCHUPS', data)
          
          if (data.matchups.all.length > 0) {

            const virtuals = data.matchups.all.filter( (mu: IMatchup) => {
              return mu.pickA.player.aspect.id.toLowerCase().startsWith('z')
            } )

            if (virtuals.length) {
              commit('SET_SETTLEMENT_TIME', virtuals[0].pickA.event.startTime)
            }
          }

          return data
        }
      })
      .catch(err => {
        console.log('Error: GET_MATCHUPS')
        return data
      })
    })
  },
  GET_PERSONALISED_MATCHUPS: async ({ commit, getters }: any): Promise<void | IMatchupList> => {
    let data: IMatchupList = {
      matchups: { all: [] }
    } as IMatchupList

    return await Auth.currentAuthenticatedUser().then( (res: object) => {
      return Storage.get(`${config.personalisedEndpoint}`, {
        level: 'protected',
        expires: 5,
        download: true,
      })
      .then(result => {
        if (_.isObject(result) && _.has(result, 'Body')) {
          // @ts-ignore
          data = JSON.parse(result.Body.toString())
          commit('SET_PERSONALISED_MATCHUPS', data)
          return data
        }
      })
      .catch(err => {
        console.log('Error: GET_PERSONALISED_MATCHUPS')
        return data
      })
    })
  },
  SET_SETTLEMENT_TIME: ({ commit }: any, time: number): void => {
    commit('SET_SETTLEMENT_TIME', time)
  },
  BUY_MORE: async ({ commit, dispatch }: any, sport: string): Promise<IBuyMoreResult> => {
    return Axios.get(`${config.apiEndpoint}/matchup/buymore/${sport}`)
    .then(result => {
      if (result.data.count) {
        dispatch('SET_BALANCE', result.data.balance)
      }
      return result.data
    })
    .catch(err => {
      console.log(err)
      return {errorCode: -1 , errorList: []} as IBuyMoreResult
    });
  },
  INJECT_BUY_MORE_LOADERS: ({ commit, getters }: any, sport: string): void => {
    let loaders: IMatchup[] = []

    _(4).times(function(n){
      loaders.push( {
        reason: 'loader',
        pickA: {
          player: {
            aspect: { id: sport }
          }
        }
      } as IMatchup)
    });

    const exists = getters.PERSONALISED_MATCHUPS

    const personalised = {
      matchups: {
        all: exists.matchups.all.concat(loaders)
      }
    }

    commit('SET_PERSONALISED_MATCHUPS', personalised)
  },
  CLEAR_GAME:({ commit }: any): void => {
    commit('CLEAR_MATCHUPS')
  },
};
